import { registerTab } from "lib/@components/tabs"
import { registerFeature } from "lib/features"
import { Lazy } from "lib/make-lazy"
import { registerConditionalPageNavigation } from "lib/routes/register-conditional-page-navigation"
import { authoringRoute } from "authoring/routes/authoring.runtime"
import { appRoute } from "routes/app/home.runtime"
import { ReviewProjectDetailRoute } from "./review-project-detail-route"
import { ReviewProjectRunListRoute } from "./review-project-run-list-route"
import { ReviewProjectRunResolutionRoute } from "./review-project-run-resolution-route"
import { canAccessProjectsTab, canAccessReviewProjectsArea } from "./review-project-route-access"
import { FEATURE_FLAG_REVIEW_PROJECTS } from "./server/feature-flag-review-projects.mjs"
import { getReviewProjectsRootPath } from "./review-project-route-paths"

registerFeature({
    numericalId: 5001,
    name: "Review Projects",
    id: FEATURE_FLAG_REVIEW_PROJECTS,
    description:
        "Internal authoring workspace for curating review projects, schedules and maintenance reference documents.",
    internalUseOnly: true,
})

registerTab({
    tab: "reviewProjectsTabs",
    id: "projects",
    title: "Projects",
    demands: `$feature-${FEATURE_FLAG_REVIEW_PROJECTS}`,
    predicate: canAccessProjectsTab,
    content: (
        <Lazy importer={() => import("./routes/review-projects-board")} extract="ReviewProjectsBoard" priority={10} />
    ),
})

appRoute.register("review-projects", renderReviewProjectsRoute("projects"))
authoringRoute.register("review-projects", renderReviewProjectsRoute("projects"))

appRoute.register("review-projects/reference-documents", renderReviewProjectsRoute("referenceDocuments"))
authoringRoute.register("review-projects/reference-documents", renderReviewProjectsRoute("referenceDocuments"))

appRoute.register("review-projects/:id", <ReviewProjectDetailRoute />)
authoringRoute.register("review-projects/:id", <ReviewProjectDetailRoute />)
appRoute.register("review-projects/:projectId/runs/:runId/schedule/:scheduleId", <ReviewProjectRunResolutionRoute />)
authoringRoute.register(
    "review-projects/:projectId/runs/:runId/schedule/:scheduleId",
    <ReviewProjectRunResolutionRoute />
)
appRoute.register("review-projects/:projectId/runs/:runId", <ReviewProjectRunListRoute />)
authoringRoute.register("review-projects/:projectId/runs/:runId", <ReviewProjectRunListRoute />)

registerConditionalPageNavigation(
    () => canAccessReviewProjectsArea(),
    getReviewProjectsRootPath("app"),
    "Review Projects",
    "mdi:file-document-edit-outline",
    {
        group: "More",
        priority: 255,
        subPaths: true,
    }
)

registerConditionalPageNavigation(
    () => canAccessReviewProjectsArea(),
    getReviewProjectsRootPath("authoring"),
    "Review Projects",
    "mdi:file-document-edit-outline",
    {
        group: "More",
        priority: 255,
        subPaths: true,
    }
)

function renderReviewProjectsRoute(defaultTab) {
    return (
        <Lazy
            importer={() => import("./routes/review-projects-route")}
            extract="ReviewProjectsRoute"
            defaultTab={defaultTab}
        />
    )
}
